// adding some validations logic for user registration form
import { required, email, minLength, sameAs, numeric } from 'vuelidate/lib/validators'

export const FORM_SIGNUP = {
  userDataForm: {
    name: {
      required,
      minLength: minLength(3)
    },
    surname: {
      required,
      minLength: minLength(3)
    },
    phonenumber: {
      numeric,
      minLength: minLength(10)
    },
    address: {
      minLength: minLength(15)
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    confirmpassword: {
      sameAs: sameAs('password')
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formRegister.js